var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00903 8.75C5.66503 8.75 3.75903 6.843 3.75903 4.5C3.75903 2.157 5.66503 0.25 8.00903 0.25C10.353 0.25 12.259 2.157 12.259 4.5C12.259 6.843 10.353 8.75 8.00903 8.75ZM8.00903 1.75C6.49203 1.75 5.25903 2.983 5.25903 4.5C5.25903 6.017 6.49203 7.25 8.00903 7.25C9.52603 7.25 10.759 6.017 10.759 4.5C10.759 2.983 9.52503 1.75 8.00903 1.75ZM15.75 19V16.019C15.75 13.358 14.244 10.25 10 10.25H6C1.756 10.25 0.25 13.357 0.25 16.019V19C0.25 19.414 0.586 19.75 1 19.75C1.414 19.75 1.75 19.414 1.75 19V16.019C1.75 15.018 2.057 11.75 6 11.75H10C13.943 11.75 14.25 15.017 14.25 16.019V19C14.25 19.414 14.586 19.75 15 19.75C15.414 19.75 15.75 19.414 15.75 19Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormUser);
export default __webpack_public_path__ + "static/media/form_user.24b8fab54f15409dc68289d387c01bae.svg";
export { ForwardRef as ReactComponent };